import { Field } from "contentful"

export default function renderNumber(field: Field): string {
  return "number"
}
